export default __webpack_public_path__ + "static/polygon-de1149ad837e76aa9986df32e09dc8c9.svg";